import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-micros-checker-rejgrid',
  templateUrl: './micros-checker-rejgrid.component.html',
  styleUrls: ['./micros-checker-rejgrid.component.scss']
})
export class MicrosCheckerRejgridComponent implements OnInit {

  public Microsoft360editdata:any={};
  constructor(public appservice:AppService,public location:Location,public router:Router) { }
 get_Microsoft360_ITfacilitygrid(){
  this.appservice.getTable("api/Transaction/getMicrosoft360_ITfacilitygrid").subscribe((res:any)=>{
    this.Microsoft360editdata=JSON.parse(res).record;
  
  });
 }

  editEmployee(id:any){
    //this.appservice.get_Microsoft360_ITfacilityeditdata(id);
    this.appservice.Microsoft360editid=id;
    console.log("the edit id",this.appservice.Microsoft360editid)
    this.router.navigateByUrl('/home/microsoft-checker-rejform');
  }
  
  ngOnInit(): void {
    this.appservice.GetMicrosoft360_checkerRejectedgrid();
  }


}
